<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";
import { errorAlert } from "../plugins/alert";
import { useHelpStore } from '../stores/help';

const help = useHelpStore();
const isOpen = ref(false);
if (help.helpExists() && help.help_key == props.helpKey) {
  isOpen.value = true;
}
const props = defineProps({
    helpKey: {
      type:String,
      default:() => {
        return '';
      }
    },
})
const helpButtonRef = ref();
const getParentNode = (elem) => {
  let result = null;
  if (elem.parentNode == null || elem.classList.contains('relative')) {
    result = elem;
  } else {
    result = getParentNode(elem.parentNode);
  }
  return result;
}
const showHelpContent = () => {
  if (help.helpExists()) {
    isOpen.value = false;
    //閉じる
    help.closeHelp();
  } else {
    isOpen.value = true;
    //relativeの親を探す
    help.showHelp(getParentNode(helpButtonRef.value),props.helpKey);
  }
}
</script>

<style scoped lang='sass'>
</style>

<template>
<div>
  <a ref="helpButtonRef" v-show="helpKey.length > 0" :class="'block text-xl leading-6 ' + helpKey" @click="showHelpContent" href="javascript:void(0)"><i v-if="!isOpen" class="fa-solid fa-circle-question"></i><i v-else class="fa-regular fa-rectangle-xmark"></i></a>
</div>
</template>

